import React from 'react';
import './Chip.scss';

export class ChipProps {
    onDelete: () => void;
    children: any;
}

export default React.memo((props: ChipProps) => (
    <span className="chip">
        {props.children}
        <button onClick={() => props.onDelete()}>
            <i className="material-icons">close</i>
        </button>
    </span>
));